export default class DtoTempRef {
    constructor(obj) {
        this.idStation = obj.idStation
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.tempRef = obj.tempRef
        this.comment = obj.comment
        this.typeId = obj.typeId
    }
}